"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubText = exports.Logo = exports.LogoContainer = exports.StyledSlider = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _typography = require("@berlitz/globals/lib/components/typography");
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var StyledSlider = (0, _styledComponents.default)(_reactSlick.default).withConfig({
  displayName: "style__StyledSlider",
  componentId: "wkkwrk-0"
})([".slick-dots{button::before{color:", ";font-size:8px;}}.slick-dots{li.slick-active{button::before{color:", ";opacity:1;}}}.slick-track{display:flex;align-items:center;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.brandPrimary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.brandPrimary;
});
exports.StyledSlider = StyledSlider;
var LogoContainer = _styledComponents.default.div.withConfig({
  displayName: "style__LogoContainer",
  componentId: "wkkwrk-1"
})(["outline:none;display:inline-flex !important;justify-content:center;"]);
exports.LogoContainer = LogoContainer;
var Logo = _styledComponents.default.img.withConfig({
  displayName: "style__Logo",
  componentId: "wkkwrk-2"
})(["max-width:160px;object-fit:contain;padding:0 ", ";max-height:80px;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.md;
});
exports.Logo = Logo;
var SubText = (0, _styledComponents.default)(_typography.P).withConfig({
  displayName: "style__SubText",
  componentId: "wkkwrk-3"
})(["margin:0 auto;margin-bottom:", ";max-width:", ";@media (min-width:", "){margin-bottom:", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.layout.xxs;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.md;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.sm;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.layout.md;
});
exports.SubText = SubText;